module.exports = __webpack_public_path__ + "img/header.b7c43ee3.png";